import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 查询欠费信息
export function queryReportOweFee(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportOweFee/queryReportOweFee',
      method: 'get',
      params: {
        ...params,
        communityId: params.communityId || getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data,
        total: res.total,
        records: res.records
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询收费项列表
export function listFeeConfigs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeConfig.listFeeConfigs',
      method: 'get',
      params: {
        ...params,
        communityId: params.communityId || getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.feeConfigs
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询楼栋列表
export function queryFloors(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/floor.queryFloors',
      method: 'get',
      params: {
        ...params,
        communityId: params.communityId || getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.apiFloorDataVoList,
        total: res.total
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询单元列表
export function queryUnits(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/unit.queryUnits',
      method: 'get',
      params: {
        ...params,
        communityId: params.communityId || getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res
      })
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 按房屋查询欠费明细（缴费人快照 + 当前绑房业主）
 * @param {{ payerObjId: string, communityId?: string }} params
 */
export function queryRoomOweFeeDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.queryRoomOweFeeDetail',
      method: 'post',
      data: {
        communityId: params.communityId || getCommunityId(),
        payerObjId: params.payerObjId
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询小区催缴明细
export function queryCommunityOweFeeDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.queryCommunityOweFeeDetail',
      method: 'post',
      data: {
        communityId: params.communityId || getCommunityId(),
        floorId: params.floorId || ''
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导出数据
export function exportData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params: {
        ...params,
        communityId: params.communityId || getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 欠费批量导入：先同步预校验，通过后后台异步落库
 * @param {{ communityId: string, rows: Array }} data
 */
export function importOweFee(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.importOweFee',
      method: 'post',
      data: {
        ...data,
        communityId: data.communityId || getCommunityId()
      },
      timeout: 300000
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      const payload = (error && error.response && error.response.data) || error
      reject(payload)
    })
  })
}